import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  FaAward,
  FaUserGraduate,
  FaCalendarAlt,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import classes from "./Activities.module.css";
import styles from "../../scholarship/Scholarship.module.css";
import { testUrl } from "../BaseData";

const Stipendiantlar = () => {
  const [students, setStudents] = useState([]);
  const [flippedCards, setFlippedCards] = useState({});
  const { i18n } = useTranslation();
  const navigate = useNavigate();

  // Fetch data from API
  useEffect(() => {
    const fetchStudents = async () => {
      try {
        const response = await axios.get(
          testUrl + "/api/scholarship-holders/"
        );
        const formattedData = response.data.map((student) => ({
          name: `${student[`name_${i18n.language}`]} ${
            student[`surname_${i18n.language}`]
          }`,
          description: student[`description_${i18n.language}`],
          image: student.image,
          scholarship: "Noma'lum",
          year: new Date().getFullYear(),
        }));
        setStudents(formattedData);
      } catch (error) {
        console.error("Error fetching students:", error);
      }
    };
    fetchStudents();
  }, [i18n.language]);

  const toggleCard = (index) => {
    setFlippedCards((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className={classes["mainContainer"]}>
      <div data-aos="fade-up" className={classes["container"]}>
        <h1 className={classes["page-title"]}>{i18n.t("ourScholarshipHolders")}</h1>
        <div className={styles.cardContainer}>
          {students.map((student, index) => (
            <div
              key={index}
              className={`${styles.card} ${
                flippedCards[index] ? styles.flipped : ""
              }`}
              onClick={() => toggleCard(index)}
            >
              <div className={styles.cardFront}>
                <img
                  src={student.image}
                  alt={student.name}
                  className={styles.studentImage}
                />
                <div className={styles.content}>
                  <h3 className={styles.studentName}>
                    <FaUserGraduate className={styles.icon} /> {student.name}
                  </h3>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: student.description,
                    }}
                  />
                </div>
              </div>

              <div className={styles.cardBack}>
                <p className={styles.description}>
                  {i18n.t("thisStudent")}
                  <div
                    dangerouslySetInnerHTML={{
                      __html: student.description,
                    }}
                  ></div>
                  {i18n.t("awardWinner")}
                </p>
                <p className={styles.year}>
                  <FaCalendarAlt className={styles.iconSmall} /> {i18n.t("year")}:{" "}
                  {student.year}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className={classes.sidebar}>
        <h3>{i18n.t("Talabalarga")}</h3>
        <ul>
          <li onClick={() => navigate("/baseactivities/talabalar-hayoti/")}>
            {i18n.t("Talabalar hayoti")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/karyera/")}>
            {i18n.t("Karyera")}
          </li>
          <li onClick={() => navigate("/university-union")}>
            {i18n.t("universityUnion")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/talabalar-turar-joyi")}>
            {i18n.t("Talabalar turar joyi")}
          </li>
          <li onClick={() => navigate("/activity/talabalarga/alochi-talabalar")}>
            {i18n.t("Iqtidorlilar va chempionlar")}
          </li>
          <li className={classes.active}>
            {i18n.t("ourScholarship")}
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Stipendiantlar; 